import React, { useState, useEffect } from "react";
import { Input, DatePicker } from "antd";
import AntDesignTable from "../common/antTable/AntDesignTable";
import axios from "axios";
import moment from "moment";
import PrescriptionDetails from "../prescription/PrescriptionDetails";
import { API_URL } from "../../config";

const { RangePicker } = DatePicker;

const PrescriptionContainer = () => {
  const [appointments, setAppointments] = useState([]);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_URL}/appointment/all/?status=COMPLETED`)
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          const data = response.data.map((item) => {
            const doctorDetails = item.doctor_details || {};
            return {
              key: item.id,
              patientName: item.patient_name ? `${item.patient_name}` : "-",
              doctorName: doctorDetails.first_name
                ? `${doctorDetails.salutation || ""} ${
                    doctorDetails.first_name || ""
                  } ${doctorDetails.last_name || ""}`.trim()
                : "-",
              startDatetime: moment(item.start_datetime).format(
                "YYYY-MM-DD HH:mm",
              ),
              endDatetime: moment(item.end_datetime).format("YYYY-MM-DD HH:mm"),
              duration: moment(item.start_datetime).format("YYYY-MM-DD HH:mm"),
              kioskOrMobile: item.mobile
                ? "Mobile"
                : item.kiosk_id
                  ? "Kiosk"
                  : "Tablet",
              mode: item.mode || "N/A",
              fullData: item,
            };
          });
          setAppointments(data);
        } else {
          console.error("Invalid data format:", response.data);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleDatePickerChange1 = (dates) => {
    setDateRange(dates || []);
  };

  const filteredAppointments = appointments.filter((appointment) => {
    const matchPatientName = appointment.patientName
      .toLowerCase()
      .includes(searchTerm);
    const matchDateRange =
      !dateRange.length ||
      (moment(appointment.startDatetime).isSameOrAfter(dateRange[0], "day") &&
        moment(appointment.startDatetime).isSameOrBefore(dateRange[1], "day"));
    return matchPatientName && matchDateRange;
  });

  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patientName",
      key: "patientName",
    },
    {
      title: "Doctor Name",
      dataIndex: "doctorName",
      key: "doctorName",
    },
    {
      title: "Appointment",
      dataIndex: "duration",
      key: "duration",
    },
    {
      title: "Device",
      dataIndex: "device",
      key: "device",
      render: (text, record) => {
        const device = record.kioskOrMobile || "";
        const mode = record.mode || "";
        if (device === "Kiosk") {
          return `${device}(${mode})`;
        } else {
          return device;
        }
      },
    },

    {
      title: "Details",
      key: "details",
      render: (text, record) => (
        <a onClick={() => handleDetails(record)}>View Details</a>
      ),
    },
  ];

  const handleDetails = (record) => {
    setSelectedPrescription(record.fullData);
  };

  const handleBack = () => {
    setSelectedPrescription(null);
  };

  return (
    <React.Fragment>
      {selectedPrescription ? (
        <PrescriptionDetails
          prescription={selectedPrescription}
          onBack={handleBack}
        />
      ) : (
        <div>
          <Input
            placeholder="Search by patient name"
            value={searchTerm}
            onChange={handleSearch}
            style={{ marginBottom: 16, width: 200 }}
          />
          <RangePicker
            showTime
            format="YYYY/MM/DD HH:mm:ss"
            onChange={handleDatePickerChange1}
            value={dateRange}
            style={{ marginBottom: 16, marginLeft: 40 }}
          />
          <AntDesignTable tableData={filteredAppointments} columns={columns} />
        </div>
      )}
    </React.Fragment>
  );
};

export default PrescriptionContainer;
